import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasReportecomisionesComponent (FinanzasReportecomisiones, $q, $catalogos, $location, $moment) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges
  $ctrl.buscar = buscar

  function $onInit () {
    $ctrl.$promise = $q.all({
      comisionistas: FinanzasReportecomisiones.getComisionistas(),
      proveedores: $catalogos.get('empresasCorporativo'),
      clientes: $catalogos.get('clientes'),
    })
      .then((resolve) => {
        $ctrl.comisionistas = resolve.comisionistas.data
        $ctrl.proveedores = resolve.proveedores
        $ctrl.clientes = resolve.clientes
      })
  }

  function $onChanges (changes) {
    if (changes.busqueda)
      $ctrl.busqueda = {
        comisionistas: $ctrl.busqueda.comisionistas || [],
        proveedores: $ctrl.busqueda.proveedores || [],
        clientes: $ctrl.busqueda.clientes || [],
        fechaInicial: $ctrl.busqueda.fechaInicial || $moment().subtract(1, 'months').toDate(),
        fechaFinal: $ctrl.busqueda.fechaFinal || new Date(),
      }
  }

  function buscar () {
    $location.search({
      comisionistas: $ctrl.busqueda.comisionistas,
      proveedores: $ctrl.busqueda.proveedores,
      clientes: $ctrl.busqueda.clientes,
      fechaInicial: $ctrl.busqueda.fechaInicial.toYMD(),
      fechaFinal: $ctrl.busqueda.fechaFinal.toYMD(),
    })
  }
}

module.component('finanzasReportecomisiones', {
  controller: FinanzasReportecomisionesComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/reportecomisiones/components/component.js